/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTagSchema } from '../models/CreateTagSchema';
import type { TagSchema } from '../models/TagSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TagsApi {
    /**
     * Create Tag
     * Create a new tag or update if name+color match.
     * @returns TagSchema OK
     * @throws ApiError
     */
    public static tagsCreateTagPost({
        requestBody,
    }: {
        requestBody: CreateTagSchema,
    }): CancelablePromise<TagSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/tags/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Tags
     * @returns TagSchema OK
     * @throws ApiError
     */
    public static tagsGetTagsGet({
        contentType,
        objectId,
    }: {
        contentType: 'visit' | 'patient',
        objectId?: (string | null),
    }): CancelablePromise<Array<TagSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/tags/',
            query: {
                'content_type': contentType,
                'object_id': objectId,
            },
        });
    }
    /**
     * Delete Tag
     * Delete a tag.
     * @returns void
     * @throws ApiError
     */
    public static tagsDeleteTagDelete({
        tagId,
    }: {
        tagId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/tags/{tag_id}/',
            path: {
                'tag_id': tagId,
            },
        });
    }
    /**
     * Remove Tag From Object
     * Untag an object.
     * @returns void
     * @throws ApiError
     */
    public static tagsRemoveTagFromObjectDelete({
        tagId,
        contentType,
        objectId,
    }: {
        tagId: string,
        contentType: 'visit' | 'patient',
        objectId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/tags/{tag_id}/tagged-objects/',
            path: {
                'tag_id': tagId,
            },
            query: {
                'content_type': contentType,
                'object_id': objectId,
            },
        });
    }
}
